var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRotateRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 13C2 9.13401 5.13401 6 9 6H19C19.5523 6 20 6.44772 20 7C20 7.55228 19.5523 8 19 8H9C6.23858 8 4 10.2386 4 13C4 15.7614 6.23858 18 9 18C11.7614 18 14 15.7614 14 13C14 12.4477 14.4477 12 15 12C15.5523 12 16 12.4477 16 13C16 16.866 12.866 20 9 20C5.13401 20 2 16.866 2 13Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.7071 6.29289C22.0976 6.68342 22.0976 7.31658 21.7071 7.70711L19.7071 9.70711C19.3166 10.0976 18.6834 10.0976 18.2929 9.70711C17.9024 9.31658 17.9024 8.68342 18.2929 8.29289L19.5858 7L18.2929 5.70711C17.9024 5.31658 17.9024 4.68342 18.2929 4.29289C18.6834 3.90237 19.3166 3.90237 19.7071 4.29289L21.7071 6.29289Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotateRight);
export default __webpack_public_path__ + "static/media/rotate-right.68438a51.svg";
export { ForwardRef as ReactComponent };